import { Component, Input, Output, EventEmitter, Self, Optional, ViewChild, HostListener } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
    selector: 'apc-ui-switch',
    templateUrl: './switch.component.html',
    styleUrls: ['./switch.component.scss'],
    standalone: false
})
export class SwitchComponent implements ControlValueAccessor {
  
  @Input() disabled: boolean;
  @Input() checked: string;

  value: boolean = false;
  @Output() isChanged = new EventEmitter<any>();
  @Input() isEdit: boolean = false;
  @ViewChild('switchEl') switchEl;

  constructor(
    @Self() @Optional() public ngControl: NgControl) {
    this.ngControl && (this.ngControl.valueAccessor = this);
  }

  @HostListener('click', ['$event'])
  checkEdit() {
    if (!this.switchEl.nativeElement.closest('.editForm')) {
      this.isEdit = true;
    } else {
      this.isEdit = false;
    }
  }

  public onChangeFn = (_: any) => { };
  public onTouchedFn = () => { };

  public registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public writeValue(obj: any): void {
    this.value = obj;
  }

  public onChange() {
    this.onChangeFn(this.value);
    this.isChanged.emit(this.value);
  }
}
